import React from 'react';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

const Label = ({
  type = 'button',
  onClick,
  children,
  className = '',
  tooltipText = undefined,
  htmlFor = ''
}) => {
  return (
    <Tooltip
      title={tooltipText ? tooltipText : undefined}
      trigger="mouseenter"
      animateFill={false}
    >
      <label
      htmlFor={htmlFor}
        type={type}
        onClick={onClick ? onClick : undefined} // only add onClick if passed
        className={className}
        style={{ cursor: onClick ? 'pointer' : 'default' }} // change cursor if clickable
      >
        {children}
      </label>
    </Tooltip>
  );
};

export default Label;
